import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ComparisonSection } from '../components/sections/ComparisonSection';
import { HighlightSection } from '../components/sections/HighlightSection';
import { ExamplesSection } from '../components/sections/ExamplesSection';
import { ProductSection } from '../components/sections/ProductSection';
import { FeaturesSection } from '../components/sections/FeaturesSection';
import { FuturePacingSection } from '../components/sections/FuturePacingSection';
import { PricingSection } from '../components/sections/PricingSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { UrgencySection } from '../components/sections/UrgencySection';
import { FAQSection } from '../components/sections/FAQSection';
import { PurchaseNotification } from '../components/ui/PurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-381">
      <HeroSection data-id="element-382" />
      <ComparisonSection data-id="element-383" />
      <HighlightSection data-id="element-384" />
      <ExamplesSection data-id="element-385" />
      <ProductSection data-id="element-386" />
      <FeaturesSection data-id="element-387" />
      <FuturePacingSection data-id="element-388" />
      <PricingSection data-id="element-389" />
      <GuaranteeSection data-id="element-390" />
      <UrgencySection data-id="element-391" />
      <FAQSection data-id="element-392" />

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12" data-id="element-393">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-394">
          <p className="text-lg mb-4" data-id="element-395">A Fórmula do Efeito Boutique™</p>
          <p className="text-gray-400 text-sm" data-id="element-396">
            © 2024 Todos os direitos reservados. | Política de Privacidade |
            Termos de Uso
          </p>
        </div>
      </footer>

      {/* Purchase Notifications */}
      <PurchaseNotification data-id="element-397" />
    </div>;
}